import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TableModule } from '@app/modules/table/table.module';
import { PlatformModule } from '@app/platform.module';
import { Components, GeneralSettingsCardComponent, TimeTypeOffCardComponent } from '@time-off-v3/components';
import { TimeOffFormsV3 } from '@time-off-v3/forms/index';
import { AccrualPolicyGuard } from '@time-off-v3/guards/accrual-policy.guard';
import { EmployeeResolver } from '@time-off-v3/resolvers/employee.resolver';
import { Views } from '@time-off-v3/views';
import { AppCommonModule } from '../common/common.module';
import { TimeOffV3FormsModule } from '../forms/time-off-v3/time-off-v3-forms.module';
import { GeneralSettingsEditComponent } from './components/settings/general-settings-edit-card/general-settings-edit-card.component';
import { Services } from './services/index';
import { StandaloneComponents } from './standalone-components';
import { TimeOffV3Resolver } from './time-off-v3.resolver';
import { TimeOffV3RouterModule } from './time-off-v3.routes';
import { InvalidControlScrollDirective } from '@app/directives/invalid-control-scroll.directive';
@NgModule({
    declarations: [...Views, ...TimeOffFormsV3, ...Components],
    imports: [
        CommonModule,
        TimeOffV3RouterModule,
        AppCommonModule,
        PlatformModule,
        FormsModule,
        TableModule,
        TimeOffV3FormsModule,
        TimeTypeOffCardComponent,
        GeneralSettingsEditComponent,
        GeneralSettingsCardComponent,
        InvalidControlScrollDirective,
        StandaloneComponents,
    ],
    providers: [TimeOffV3Resolver, ...Services, EmployeeResolver, AccrualPolicyGuard],
})
export class TimeOffV3Module {}
